module.exports = __webpack_public_path__ + "img/clone-sheep.93e1e5a7.svg";